import React, { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ProjectModal } from './ProjectModal';
const projects = [{
  id: 1,
  title: 'Bikebosque',
  category: 'Brand Identity',
  year: '2024',
  image: 'https://cdn.magicpatterns.com/uploads/5kiDeygQUjbnM9BAdWXAXo/WEB_01.png',
  height: 'h-[400px]',
  detailImages: ['https://cdn.magicpatterns.com/uploads/5kiDeygQUjbnM9BAdWXAXo/WEB_01.png', 'https://cdn.magicpatterns.com/uploads/jjXMA2ss2qwdqwJQ3QuTSM/WEB_02.png', 'https://cdn.magicpatterns.com/uploads/mXYDUGEG6Fb3oGjzpXLzcD/WEB_03.png', 'https://cdn.magicpatterns.com/uploads/iwcrenaPTn1JLV9KkhmTZW/WEB_04.png', 'https://cdn.magicpatterns.com/uploads/tQzuevRzZJ74tKrjQoWwah/WEB_05.png', 'https://cdn.magicpatterns.com/uploads/hAJa2KuLVQrZn1YV7kPavn/WEB_06.png', 'https://cdn.magicpatterns.com/uploads/pV9BEHmY5MZtvKfQMwHLjZ/WEB_07.png']
}, {
  id: 2,
  title: 'Ayam Bakar Pancasan',
  category: 'Brand Identity',
  year: '2022',
  image: 'https://cdn.magicpatterns.com/uploads/buSgHHX1ewNGubdDr7KyhT/Ayam_Bakar_Pancasan_00.png',
  height: 'h-[350px]',
  detailImages: ['https://cdn.magicpatterns.com/uploads/buSgHHX1ewNGubdDr7KyhT/Ayam_Bakar_Pancasan_00.png', 'https://cdn.magicpatterns.com/uploads/fReBVf3tw9NHysF5nAZZ1W/Ayam_Bakar_Pancasan_01.png', 'https://cdn.magicpatterns.com/uploads/7bCSWFQbs1NYiw767dVLd8/Ayam_Bakar_Pancasan_02.png', 'https://cdn.magicpatterns.com/uploads/tC9NfQ45PWPBiqywA9NGxq/Ayam_Bakar_Pancasan_03.png', 'https://cdn.magicpatterns.com/uploads/4pgLA9MpywiKKBYjZH7uCJ/Ayam_Bakar_Pancasan_04.png', 'https://cdn.magicpatterns.com/uploads/cHJi9N5jefyU5CCNNN6zBN/Ayam_Bakar_Pancasan_05.png', 'https://cdn.magicpatterns.com/uploads/joZkpK5YY9svsRB2vPGeZb/Ayam_Bakar_Pancasan_06.png']
}, {
  id: 3,
  title: 'Jersey Army ID',
  category: 'Brand Identity',
  year: '2023',
  image: 'https://cdn.magicpatterns.com/uploads/hmLX5mQzW5QBEiX3gBKo45/JAI-logo_00.png',
  height: 'h-[300px]',
  detailImages: ['https://cdn.magicpatterns.com/uploads/hmLX5mQzW5QBEiX3gBKo45/JAI-logo_00.png', 'https://cdn.magicpatterns.com/uploads/8HWUPFLTPq3CTpsFZjvgYq/JAI-logo_01.png', 'https://cdn.magicpatterns.com/uploads/krGx5yka6hWHrgbxdxFK1p/JAI-logo_02.png', 'https://cdn.magicpatterns.com/uploads/95BghFCTXF4CEkuSw4qViz/JAI-logo_03.png']
}, {
  id: 4,
  title: 'Punya Saka',
  category: 'Brand Identity',
  year: '2020',
  image: 'https://cdn.magicpatterns.com/uploads/aQNs4QRuhozkYfqKxbCpvf/Punya_Saka_-_Logo_00.png',
  height: 'h-[320px]',
  detailImages: ['https://cdn.magicpatterns.com/uploads/aQNs4QRuhozkYfqKxbCpvf/Punya_Saka_-_Logo_00.png', 'https://cdn.magicpatterns.com/uploads/7gDdy3n949XpmXXmDxTzuz/Punya_Saka_-_Logo_01.png', 'https://cdn.magicpatterns.com/uploads/mWyn1oHv7ezyhJzdxyEqvR/Punya_Saka_-_Logo_02.png', 'https://cdn.magicpatterns.com/uploads/3bj9tfvRRuZgB4fpFdvWh9/Punya_Saka_-_Logo_03.png', 'https://cdn.magicpatterns.com/uploads/edaLLuQGocgF79oegAHWkY/Punya_Saka_-_Logo_04.png']
}, {
  id: 5,
  title: 'Tea Di Tu',
  category: 'Brand Identity',
  year: '2021',
  image: 'https://cdn.magicpatterns.com/uploads/m8AYnCdA6pFFjPEic4Cq81/TeaDitu-Logo-v3-rev02_00.png',
  height: 'h-[340px]',
  detailImages: ['https://cdn.magicpatterns.com/uploads/m8AYnCdA6pFFjPEic4Cq81/TeaDitu-Logo-v3-rev02_00.png', 'https://cdn.magicpatterns.com/uploads/uFdtPCMdZvB1J23tC6koh3/TeaDitu-Logo-v3-rev02_01.png', 'https://cdn.magicpatterns.com/uploads/drjewWA992KESybtBPmmtc/TeaDitu-Logo-v3-rev02_02.png', 'https://cdn.magicpatterns.com/uploads/e9Cgbhp7eku9ycZNzrDgLj/TeaDitu-Logo-v3-rev02_03.png']
}];
export function ProjectGrid() {
  const [selectedProject, setSelectedProject] = useState<(typeof projects)[0] | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleProjectClick = (project: (typeof projects)[0]) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };
  return <section id="work" className="py-24 px-6 bg-black" data-id="element-86">
      <div className="max-w-7xl mx-auto" data-id="element-87">
        <div className="flex justify-between items-end mb-16" data-id="element-88">
          <div data-id="element-89">
            <h2 className="text-yellow-400 font-bold tracking-widest uppercase mb-2" data-id="element-90">
              Selected Work
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold text-white" data-id="element-91">
              Featured Projects
            </h3>
          </div>
          <Link to="/work" className="hidden md:flex items-center text-white hover:text-yellow-400 transition-colors uppercase font-bold tracking-wider text-sm" data-id="element-92">
            View All Work <ArrowUpRight className="ml-2 w-4 h-4" data-id="element-93" />
          </Link>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8" data-id="element-94">
          {projects.map(project => <div key={project.id} onClick={() => handleProjectClick(project)} className="group relative break-inside-avoid overflow-hidden cursor-pointer" data-id="element-95">
              <div className={`w-full ${project.height} relative`} data-id="element-96">
                <img src={project.image} alt={project.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 grayscale group-hover:grayscale-0" data-id="element-97" />

                {/* Overlay */}
                <div className="absolute inset-0 bg-yellow-400/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-center items-center p-8 text-center" data-id="element-98">
                  <span className="text-black font-bold tracking-widest uppercase text-sm mb-4 translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-75" data-id="element-99">
                    {project.category}
                  </span>
                  <h3 className="text-black text-3xl font-black uppercase tracking-tighter translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-100" data-id="element-100">
                    {project.title}
                  </h3>
                  <div className="mt-6 w-12 h-1 bg-black transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 delay-150" data-id="element-101" />
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center md:hidden" data-id="element-102">
          <Link to="/work" className="inline-flex items-center text-white hover:text-yellow-400 transition-colors uppercase font-bold tracking-wider text-sm" data-id="element-103">
            View All Work <ArrowUpRight className="ml-2 w-4 h-4" data-id="element-104" />
          </Link>
        </div>
      </div>

      <ProjectModal project={selectedProject} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-105" />
    </section>;
}